export const ENVIRONMENT = {
  name: 'prod',
  apiName: 'prod',
  isProduction: true,
  fullName: 'Production',
  color: '#22c55e',
  appName: 'Insight Engine UI',
  oktaGroups: {
    campaign_manager: 'LCM-Insight_Engine-Prod_Campaign_Manager',
    qa: 'LCM-Insight_Engine-Prod_QA_Tester',
    promoter: '',
    drb_user: 'LCM-Insight_Engine-DRB_User',
    drb_manager: 'LCM-Insight_Engine-DRB_Manager'
  },
  bundleNames: ['marketing', 'marketing_translations']
};

export const CONFIG = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_QIZstSrCm',
  aws_user_pools_web_client_id: '5jgt63ao17539q0rlkbgd82k3s',
  aws_cognito_identity_pool_id: 'us-east-1:a22feafb-d234-4798-b3b3-134f39deb6e5',
  API: {
    endpoints: [
      {
        name: 'development',
        endpoint: 'https://8vg827nz0c.execute-api.us-east-1.amazonaws.com',
        region: 'us-east-1'
      }
    ]
  },
  oauth: {
    domain: 'insight-engine-prod.auth.us-east-1.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: 'https://engine.app.insights-prod.data.irobotapi.com/callback',
    redirectSignOut: 'https://engine.app.insights-prod.data.irobotapi.com/signout',
    responseType: 'code'
  },
  federationTarget: 'COGNITO_USER_POOLS'
};
